import type { Audit } from "@/services/api/guardiansv2/types";

/** True when an audit is queued, running, or has a tracked runner task in flight. */
export function isAuditPending(
  audit: Audit | null | undefined,
  trackedInFlight = false
): boolean {
  if (trackedInFlight) return true;
  if (!audit) return false;
  return audit.status === "queued" || audit.status === "running";
}
